<template>
    <form class="addValues" v-if="!loader">
        <div className="grid-12">
            <label>Atendimento</label>
            <select class="input" v-model="form.id_atendimento">
                <option value="">Selecione</option>
                <option v-for="at in atendimentos_nao_cancelados" :key="at.id" :value="at.id">{{ at.id }} - Supporter {{ at.nome_doutor }} - {{
                    at.dh_checkin | date }} </option>
            </select><br />
            <label>Tipo de lançamento</label>
            <select @change="costs" class="input" v-model="form.tipo_lancamento">
                <option value="">Selecione</option>
                <option value="reembolso_ns">Pagamento adicional por conta da NetSupport</option>
                <option value="reembolso_cliente">Pagamento adicional por conta do Cliente</option>
                <option value="cobranca_cliente">Cobrança cliente</option>
                <option value="desconto_pagamento">Desconto pagamento</option>
                <option value="hora_extra">Hora extra</option>
            </select>
            <div v-if="form.tipo_lancamento == 'reembolso_ns'" class="danger mb">ATENÇÂO!!! Este valor não será cobrado
                do
                cliente é será de total responsabilidade da NetSupport.</div>
            <div v-if="limite_lancamento_custo" class="danger mb">{{ limite_lancamento_custo }}</div>
        </div>
        <template v-if="form.id_atendimento">
            <div v-if="form.tipo_lancamento == 'reembolso_ns' || form.tipo_lancamento == 'reembolso_cliente' || form.tipo_lancamento == 'cobranca_cliente'"
                class="row column-s">
                <div class="mb grid-6 grid-12-s">
                    <label>Valor Supporter</label>
                    <Money v-model="form.valor_doutor" placeholder="0,00" v-bind="money" required />
                </div>
                <div class="mb grid-6 grid-12-s" v-if="form.tipo_lancamento == 'cobranca_cliente'">
                    <label>Valor Cliente</label>
                    <Money v-model="form.valor_cliente" placeholder="0,00" v-bind="money" />
                </div>
            </div>
            <div v-else class="row column-s">
                <div v-if="form.tipo_lancamento == 'desconto_pagamento'" class="mb grid-6 grid-12-s">
                    <label>Desconto <i>(hh:mm)</i></label>
                    <input @change="calc(form.duracao_desconto)" type="time" v-model="form.duracao_desconto"
                        placeholder="00:00" required />
                    <div v-if="total" class="danger"><br>{{ total }}</div>
                </div>
                <div v-if="form.tipo_lancamento == 'hora_extra'" class="mb grid-6 grid-12-s">
                    <label>Hora extra <i>(hh:mm)</i></label>
                    <input @change="calc(form.duracao_hora_extra)" type="time" v-model="form.duracao_hora_extra"
                        placeholder="00:00" required />
                    <div v-if="total" class="danger"><br>{{ total }}</div>
                </div>
            </div>
            <div class="mb grid-12 column">
                <label>Histórico</label>
                <input v-model="form.historico" class="input"
                    placeholder="Informe o motivo / justificativa deste lançamento" required />
            </div>

            <Button layout="green-go" @click="add" :loader="btloader"><i class="fa fa-road" /> LANÇAR</Button>
        </template>
    </form>
    <div v-else class="loader-container column align-center justify-center">
        <Loader />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";
import { Money } from "v-money";

export default {
    name: "AddValues",
    props: { modal: Object },
    components: { Button, Loader, Money },
    data() {
        return {
            money: {
                decimal: ",",
                thousands: ".",
                precision: 2,
                masked: false,
            },
            limite_lancamento_custo: '',
            total: '',
            atendimentos: [],
            loader: true,
            btloader: false,
            form: { historico: "", id_atendimento: "", km_total: "", destinatario: null, mensagem: null, valor_cliente: 0.00, valor_doutor: "", tipo_lancamento: "" }
        };
    },
    methods: {
        ...mapActions("job", ["LOAD_ATTENDANCE", "COST_LIMIT"]),
        ...mapActions("admin", ["JOB_VALOR_ADICIONAL"]),
        calc(h) {
            const horas = parseInt(h.slice(0, 2)) * 60;
            let min = parseInt(h.slice(3, 5));
            this.total = `Total: aprox. R$ ${parseFloat((horas + min) * this.modal.job.valor_hora_extra / 60).toFixed(2)}`
        },
        async costs() {
            this.total = ''
            this.limite_lancamento_custo = ''
            if (this.form.tipo_lancamento == 'reembolso_ns' || this.form.tipo_lancamento == 'reembolso_cliente') {
                this.COST_LIMIT(this.modal.id).then(({ data }) => {
                    if (data && data.limite > -1 && data.limite != "null" && data.limite != null)
                        this.limite_lancamento_custo = "Limite disponível para lançamentos: R$ " + (parseFloat(data.limite).toFixed(2)) + "."
                })
            }
        },
        async add() {
            this.btloader = true;
            this.form.job = this.modal.id
            await this.JOB_VALOR_ADICIONAL(this.form)
            this.modal.show = false
            this.btloader = false;
        },
        load_atendimentos() {
            this.LOAD_ATTENDANCE(this.modal.id).then(r => {
                this.atendimentos = r;
                this.loader = false;
            }).catch(() => this.loader = false);
        }
    },
    beforeMount() {
        this.load_atendimentos()
    },
    computed: {
        ...mapGetters("user", ["user"]),
        atendimentos_nao_cancelados() {
            return this.atendimentos.filter(at => at.status != "cancelado")
        },
    },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *  
.addValues
    padding: 30px
    @include label        
    .input
        margin-top: 8px
        margin-bottom: 22px
    .mb
        margin-bottom: 20px
        input
            margin-top: 6px
            width: 92%
    .danger
        color: $red-1
.loader-container
    margin-top: 40px
    padding: 30px
</style>